import { Link } from "react-router-dom";
import { Dribbble, Activity, Swords, CircleDot, Hand, Volleyball, PersonStanding, MoreHorizontal, ArrowRight } from "lucide-react";
import { sportLabel } from "@/lib/utils";
import { useT } from "@/lib/i18n";

const ICONS = { football: CircleDot, basketball: Dribbble, athletics: Activity, combat: Swords, handball: Hand, volleyball: Volleyball, women: PersonStanding, more: MoreHorizontal };

export const SportTiles = ({ sports }) => {
  const { t } = useT();
  return (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8" data-testid="sport-tiles">
    {sports.map((s, i) => {
      const I = ICONS[s.slug] || MoreHorizontal;
      return (
        <Link key={s.slug} to={`/${s.slug}`} data-testid={`sport-tile-${s.slug}`}
          className={`rise rise-${(i % 4) + 1} group relative flex aspect-[1/1.05] flex-col items-center justify-center gap-3 overflow-hidden rounded-xl text-white transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-12px_rgba(0,0,0,.5)]`}
          style={{ background: `linear-gradient(160deg, ${s.color} 0%, ${s.color} 55%, rgba(0,0,0,.35) 100%)` }}>
          <span className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-white/10 transition-transform duration-500 group-hover:scale-[2.2]" />
          <span className="relative grid h-12 w-12 place-items-center rounded-full bg-white/15 transition-colors group-hover:bg-[#F5B301] group-hover:text-[#0B1120]"><I size={26} /></span>
          <span className="relative text-sm font-bold">{t(sportLabel(s.slug))}</span>
        </Link>
      );
    })}
  </div>
  );
};

export const AppPromo = () => {
  const { t } = useT();
  return (
  <section className="relative grain overflow-hidden bg-[#0B1120] text-white" data-testid="app-promo-section">
    <div className="container-x grid items-center gap-8 py-12 lg:grid-cols-2">
      <div className="relative hidden h-64 lg:block">
        <div className="absolute left-0 top-4 h-56 w-[85%] -rotate-3 overflow-hidden rounded-2xl shadow-2xl">
          <img src="https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&q=70&w=900" alt="" className="h-full w-full object-cover" />
        </div>
        <div className="absolute right-8 top-0 w-36 rotate-6 overflow-hidden rounded-[1.6rem] border-4 border-slate-800 bg-white shadow-2xl">
          <img src="/logo.png" alt="" className="mt-4 px-3" />
          <img src="https://images.unsplash.com/photo-1577471488278-16eec37ffcc2?crop=entropy&cs=srgb&fm=jpg&q=60&w=400" alt="" className="mt-3 h-40 w-full object-cover" />
        </div>
      </div>
      <div>
        <h2 className="font-display text-4xl font-extrabold sm:text-5xl">{t("Never Miss a Moment")}</h2>
        <p className="mt-3 text-slate-300">{t("Latest news, live scores, exclusive stories and more. All Cameroonian sport. One place.")}</p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <Link to="/news" className="btn-gold" data-testid="app-promo-join-btn">{t("Join MiniSports")} <ArrowRight size={16} /></Link>
          <div className="flex gap-3">
            {["App Store", "Google Play"].map((s) => (
              <span key={s} className="flex items-center gap-2 rounded-lg border border-white/20 bg-black px-3 py-2 text-left"><span className="text-[9px] leading-tight text-slate-300">{s === "App Store" ? "Download on the" : "GET IT ON"}<br /><b className="text-sm text-white">{s}</b></span></span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
